export class PetroleumFlowFilter {
    public resource: string;
    public dataType: string;

    constructor() {}
}
